import type { ProductTypes } from 'modules/products'

export enum PromotionType {
  FREE_DELIVERY = 'dostawa',
  NORMAL = 'normal'
}

export type ActivePromotionState = {
  quantity: number | null | undefined
  freeDelivery?: boolean
  type: PromotionType
}

export type PromotionInformation = {
  conditionDescription: React.ReactNode
  targetDescription: React.ReactNode
  targetProduct: ProductTypes | null
  targetProductGroup: ProductTypes[] | null
  promotionCategory: ProductTypes[] | null
  promotionBrand: ProductTypes[] | null
  promotionGroup: ProductTypes[] | null
}
